import { Badge } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";

/** Shared on/off pill for permission-gated sections (menu, timeline, DJ). */
export function OnOffBadge({ on }: { on: boolean }) {
  const { t } = useTranslation();
  return on ? (
    <Badge className="bg-green-600 text-white hover:bg-green-600">
      {t("siteDetail.permissions.on")}
    </Badge>
  ) : (
    <Badge variant="outline">{t("siteDetail.permissions.off")}</Badge>
  );
}
